import React, { forwardRef } from 'react'

import { Container, Label } from './styles'
import { message } from '~/services'
import { DatePickerMultiple, DatePickerMultipleProps, PopoverFilter, PopoverFilterHandles } from '~/components/shared'

export const CalendarFilter = forwardRef<PopoverFilterHandles, DatePickerMultipleProps>(
  ({ date, enabledDays, onConfirm, onAction }, ref): JSX.Element => {
    return (
      <Container>
        <Label>{message('historyLaboratoryTests.select_period')}</Label>
        <PopoverFilter
          ref={ref}
          position="left"
          active={date && date?.length > 0}
          iconName="dateRange"
          svgFilled
          tooltipDescription="Selecionar data"
        >
          <DatePickerMultiple
            date={date}
            enabledDays={enabledDays}
            maxOfSelectedDates={6}
            onConfirm={onConfirm}
            onAction={onAction}
          />
        </PopoverFilter>
      </Container>
    )
  }
)

CalendarFilter.displayName = 'CalendarFilter'
